import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'sportsline-free-expert-pick-header',
  styleUrl: 'sportsline-free-expert-pick-header.css',
  shadow: true,
})
export class SportslineFreeExpertPickTitleAndExpert {
  /**
   * The title to be displayed in the card.
   */
  @Prop() cardTitle: string;

  render() {
    return (
      <Host>
        <div class="sportsline-free-expert-pick-header">
          <div class="sportsline-free-expert-pick-header-bar"></div>
          <div class="sportsline-free-expert-pick-header-wrapper">
            <div class="sportsline-free-expert-pick-header-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none">
                <path
                  d="M13.8182 38L10.3636 32.2095L3.81818 30.7619L4.45455 24.0667L0 19L4.45455 13.9333L3.81818 7.2381L10.3636 5.79048L13.8182 0L20 2.62381L26.1818 0L29.6364 5.79048L36.1818 7.2381L35.5455 13.9333L40 19L35.5455 24.0667L36.1818 30.7619L29.6364 32.2095L26.1818 38L20 35.3762L13.8182 38ZM15.3636 33.3857L20 31.3952L24.7273 33.3857L27.2727 29.0429L32.2727 27.8667L31.8182 22.8L35.1818 19L31.8182 15.1095L32.2727 10.0429L27.2727 8.95714L24.6364 4.61429L20 6.60476L15.2727 4.61429L12.7273 8.95714L7.72727 10.0429L8.18182 15.1095L4.81818 19L8.18182 22.8L7.72727 27.9571L12.7273 29.0429L15.3636 33.3857ZM18.0909 25.4238L28.3636 15.2L25.8182 12.5762L18.0909 20.2667L14.1818 16.4667L11.6364 19L18.0909 25.4238Z"
                  fill="#10D669"
                />
              </svg>
            </div>
            <h1 class="sportsline-free-expert-pick-header-title">{this.cardTitle}</h1>
          </div>
          <slot />
        </div>
      </Host>
    );
  }
}
